import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts'; // Ensure this path is correct
import { Matter } from '@/api/types/backend-dto-types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

const useFetchOrgMatters = (orgId: string = '') => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<Matter[]>(
    'fetchOrgMatters',
    () => {
      const queryParams = new URLSearchParams({ orgId }).toString();
      return fetch(`${APIBaseChronos}/api/org/matters?${queryParams}`, fetchConfigGET)
        .then((res) => res.json())
        .catch((err) => {
          console.error(err);
        });
    },
    {
      cacheTime: 0,
      enabled: true,
    },
  );
};

export default useFetchOrgMatters;
